import { Shift } from '../../../contexts/ShiftProvider.types';
import PdfScenarioDetail from './PdfScenarioDetail';
import useSummaryData from './useSummaryData';
import useTableData from './useTableData';

export const usePdfScenarioDetail = ({
  scenario,
  day,
  shifts = [],
}: {
  scenario: string;
  day: string | number;
  shifts?: Shift[];
}) => {
  const { tableData } = useTableData(shifts, {
    shiftLength: '',
    providerType: '',
    selectedDay: day === '' ? '' : Number(day),
  });
  const { tableData: summaryTableData } = useSummaryData(tableData?.rows || []);
  return {
    renderer: PdfScenarioDetail({
      tableData: tableData?.rows || [],
      summaryData: summaryTableData.rows || [],
    }),
    isLoading: false,
  };
};
export default usePdfScenarioDetail;
